import { withInstall } from '@zoryn/utils'
import Alert from './src/alert.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZAlert: SFCWithInstall<typeof Alert> = withInstall(Alert)
export default ZAlert

export * from './src/alert'
export type { AlertInstance } from './src/instance'
